const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins
const { setPreInitSlideA11yState } = window.BAO.Carousel

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    setPreInitSlideA11yState(this.els.slides.element, this.els.slide.selector)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 10,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4.1,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useA11y({
          label: 'Product carousel',
          instructions:
            'Product carousel. Use left and right arrow keys to navigate between products.',
          announceSlides: true,
          announcementPrefix: 'Product carousel',
          includeTabindex: false,
        }),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
